<app-slot (onClosePopup)="close($event)"
[data]="data"
[productData]="productData" [bookerId]="bookerId"></app-slot>